import { Dropdown } from 'core-components/library/dropdown'
import { TStaticPropsType } from 'core-components/sitebuilder/models/IWidget'
import { useStaticCrud } from 'core-components/types/helpers'

import { DEFAULT_TYPE, STATIC_PROPS_TYPE_DATA } from './constants/staticPropsType'

interface ITypeSelector {
  value: string | undefined
  onChange: (newValue: string) => void
  items?: { key: TStaticPropsType; value: string }[]
  disabled: boolean
  className?: string
}

export const TypeSelector = ({
  value,
  onChange,
  className,
  disabled,
  items = STATIC_PROPS_TYPE_DATA,
}: ITypeSelector) => {
  const typeCrud = useStaticCrud({ data: items })

  return (
    <Dropdown
      classes={{ controlClasses: { root: className } }}
      caption={'value'}
      disabled={disabled}
      source={typeCrud}
      label="Status"
      value={value || DEFAULT_TYPE}
      onChange={onChange}
    />
  )
}
